import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-infonota-continuar', e, {
      timeOutTime: 200
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label
        text='FECHA'
        htmlFor='inputDate-infonota-fechaDocumento'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        <Field name='fechaDocumento'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='inputDate-infonota-fechaDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFormGroup)
